import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { Claim } from "@/components/Layout/Claim/Claim";
import { FCC } from "@/types";
import { getCurrentVersion } from "@/utils/versionCheck";

import { FooterMenu } from "./FooterMenu";

type Styles = {
  footerText?: string;
  footerLink?: string;
};

interface FooterNewProps {
  customStyles?: Styles;
  link?: string;
  linkText?: string;
  text?: string;
  noClaim?: boolean;
}

export const WelcomeScreenFooter: FCC<FooterNewProps> = ({
  customStyles,
  link,
  linkText,
  text,
  noClaim,
}) => {
  const { t } = useTranslation();
  const version = getCurrentVersion();

  return (
    <footer className="mt-10 flex flex-col px-10">
      <div className="md:hidden">
        <p
          className={clsx(
            "text-lg text-white md:text-black",
            customStyles?.footerText,
          )}
        >
          {text}
        </p>
        <a
          href={link}
          className={clsx(
            "whitespace-nowrap text-lg font-semibold text-highlight-100 hover:underline md:text-secondary-100",
            customStyles?.footerLink,
          )}
          target="_blank"
          rel="noreferrer"
        >
          {linkText}
        </a>
      </div>
      <div className="flex w-full flex-col justify-start md:flex-row md:items-end md:justify-end [@media(min-width:740px)]:min-h-[100px] [@media(min-width:740px)]:flex-row-reverse [@media(min-width:740px)]:items-center [@media(min-width:740px)]:justify-between">
        <div className="mt-8 flex items-center md:fixed md:bottom-10 md:right-0 md:mr-20 md:mt-4 smPlus:static smPlus:m-0 smPlus:mt-0">
          <FooterMenu />
        </div>
        {!noClaim && (
          <div className="md:hidden smPlus:flex smPlus:flex-col smPlus:items-center smPlus:gap-2">
            <Claim />
          </div>
        )}
      </div>
      <div className="mt-4 text-xs text-white text-opacity-75 md:mt-0 md:text-black">
        {t("Footer.version")} {version}
      </div>
    </footer>
  );
};
